import { MEvaluationCreator } from './evaluation-creator.model';
import { VersionEvaluation } from '../interfaces/Organization';

export class MVersionEvaluation{
    public id: number = null;
    public moduleSubversionId: number = null;
    public status: string = null;
    public creator: MEvaluationCreator = null;
    public startDate: string = null;
    public endDate: string = null;

    constructor(eva: VersionEvaluation){
        this.id = eva.id;
        this.creator = new MEvaluationCreator(eva.usuario_creador);
        this.moduleSubversionId = parseInt(eva.subversion_modulo_id);
        this.status = eva.status;
        this.startDate = eva.fecha_apertura;
        this.endDate = eva.fecha_cierre;
    }
}